import { Box, MenuItem, TextField } from "@mui/material";

const today = new Date().toISOString().slice(0, 10);

export const defaultDateRangeFilter = {
  range: "last30",
  fromDate: "",
  toDate: today,
};

export function buildDateRangeParams(filter = defaultDateRangeFilter) {
  const params = { range: filter.range || "last30" };
  if (filter.range === "custom") {
    if (filter.fromDate) params.fromDate = filter.fromDate;
    if (filter.toDate) params.toDate = filter.toDate;
  }
  return params;
}

export default function DateRangeFilter({ value, onChange, sx }) {
  const filter = value || defaultDateRangeFilter;

  const update = (patch) => {
    onChange({ ...filter, ...patch });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap", ...sx }}>
      <TextField
        select
        size="small"
        label="Date range"
        value={filter.range || "last30"}
        onChange={(e) => update({ range: e.target.value })}
        sx={{ minWidth: 160 }}
      >
        <MenuItem value="last30">Last 30 days</MenuItem>
        <MenuItem value="custom">Custom</MenuItem>
      </TextField>
      {filter.range === "custom" && (
        <>
          <TextField
            size="small"
            type="date"
            label="From"
            value={filter.fromDate || ""}
            onChange={(e) => update({ fromDate: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            size="small"
            type="date"
            label="To"
            value={filter.toDate || today}
            onChange={(e) => update({ toDate: e.target.value })}
            inputProps={{ max: today }}
            InputLabelProps={{ shrink: true }}
          />
        </>
      )}
    </Box>
  );
}
